export default __webpack_public_path__ + "static/media/Archer-Medium.f0186459.ttf";